import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { t } from 'ttag';
import { Button, Input, Modal } from 'components';

import { RiLoginBoxFill } from 'react-icons/ri';

import GoogleSignin from '../../assets/Google-Signin.svg';

function Login({
  isOpen,
  onClose,
  handleEmailLogin,
  handleGoogleLogin,
  loginHeading
}) {
  /**
   * The Validation Schema for the Formik Form.
   * @type {Yup.ObjectSchema}
   */
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string()
          .email(t`The email is not valid.`)
          .required(t`An email is required.`)
      }),
    []
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      title={loginHeading}
      maxWidth="md"
    >
      <p className="m-0 text-sm text-dark-gray">
        {t`Unlock your member benefits. Enter your email below to log in or become a member.`}
      </p>
      <Formik
        initialValues={{
          email: ''
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleEmailLogin(values, '/auth/api/complete/email/', setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="pt-4">
            <Field name="email">
              {({ field, meta }) => (
                <Input
                  {...field}
                  id="login-email"
                  label="Email"
                  type="email"
                  isRequired
                  isInvalid={meta.touched && meta.error}
                  errorMessage={meta.error}
                  isValid={meta.touched && !meta.error}
                />
              )}
            </Field>
            <Button
              variant="primary"
              alignment="left"
              type="submit"
              icon={<RiLoginBoxFill className="h-4 w-4 shrink-0" />}
              isLoading={isSubmitting}
              isFullWidth
            >
              {t`Continue`}
            </Button>
          </Form>
        )}
      </Formik>
      <div className="relative flex items-center py-4">
        <div className="flex-grow border-0 border-t border-solid border-gray" />
        <span className="mx-4 flex-shrink text-xs text-gray">
          {t`or continue with`}
        </span>
        <div className="flex-grow border-0 border-t border-solid border-gray" />
      </div>
      <button
        className="m-0 h-10 border-0 bg-transparent p-0 focus:outline-none focus:ring-2 focus:ring-deep-blue focus:ring-offset-2"
        type="button"
        onClick={() => handleGoogleLogin('/auth/api/login/google-oauth2/')}
      >
        <img src={GoogleSignin} alt="" />
      </button>
    </Modal>
  );
}

Login.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  handleEmailLogin: PropTypes.func.isRequired,
  loginHeading: PropTypes.string.isRequired
};

Login.defaultProps = {
  isOpen: false,
  onClose: () => {}
};

export default Login;
